import InteractiveMaterialsView from "@features/tools/view/interactive-materials-view";

const InteractiveMaterials = () => {
  return <InteractiveMaterialsView />;
};

export default InteractiveMaterials;
